import { render, staticRenderFns } from "./ChangeStatusModal.vue?vue&type=template&id=65b0cd7f&scoped=true"
import script from "./ChangeStatusModal.vue?vue&type=script&lang=js"
export * from "./ChangeStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b0cd7f",
  null
  
)

export default component.exports